import React from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {IExpressOrder} from 'plugins/modules/filter/types';
import {Schedule} from 'modules/wineshops-list/helpers/schedule';

interface IWineryScheduleProps {
    schedule: IExpressOrder['typedSchedule'];
}

export const WinerySchedule = (props: IWineryScheduleProps) => {
    const {schedule} = props;
    const formattedSchedule = new Schedule(schedule).formattedSchedule;

    return (
        <div className={style.container}>
            <Icon icon={'pin'} width={20} height={20} className={style.wineryRowIcon} />
            <table className={style.scheduleItems}>
                <tbody>
                    {formattedSchedule.map((item) => {
                        const [day] = Object.keys(item);
                        const [range] = Object.values(item);

                        return (
                            <tr key={day} className={style.scheduleRow}>
                                <td className={style.scheduleDay}>
                                    <Typography variant={'label-14-r'}>{day}: </Typography>
                                </td>
                                <td className={style.scheduleTime}>
                                    <Typography variant={'label-14-r'}>
                                        {range.from}—{range.to}
                                    </Typography>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
